import { render } from "./DetailListInvoiceNonPo.vue?vue&type=template&id=3620a460&scoped=true"
import script from "./DetailListInvoiceNonPo.vue?vue&type=script&lang=js"
export * from "./DetailListInvoiceNonPo.vue?vue&type=script&lang=js"

import "./DetailListInvoiceNonPo.vue?vue&type=style&index=0&id=3620a460&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3620a460"]])

export default __exports__